/**
 * Логотип eAkimat365 | Аналитический комплекс (redesign).
 * Круглая эмблема и надпись — SVG-экспорты из Figma (src/assets/logos/).
 * Живёт в тёмной шапке; ссылка на главную.
 *
 * До `xl` подзаголовок и разделитель скрыты: на планшете эти ~130 px
 * забирали место у вкладок разделов, и подписи вкладок наезжали на правый
 * блок шапки.
 */
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import logoText from '../../assets/logos/logo.svg';
import mainCircle from '../../assets/logos/mainCircle.svg';

export const Logo = () => {
  const { t } = useTranslation();
  return (
    <Link to="/" className="flex shrink-0 items-center gap-2.5">
      <img src={mainCircle} alt="" className="size-[30px] shrink-0" />
      <img src={logoText} alt="eAkimat365" className="h-[17px] w-auto" />
      <span className="hidden h-6 w-px shrink-0 bg-white/15 xl:block" />
      <span className="hidden w-[112px] text-[9px] font-semibold uppercase leading-[1.35] tracking-[0.14em] text-white/45 xl:block">
        {t('brand.subtitle')}
      </span>
    </Link>
  );
};
